import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { truncate } from 'lodash/string';

class FeaturedOrgBannerCard extends Component {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillMount() {

  }


  componentDidMount() {

  }

  render() {
    let name = this.props.name;
    let description = this.props.description;
    let orgImgUrl = this.props.orgImgUrl;
    let rootCategories = this.props.rootCategories;

    let rootCategoriesStr = rootCategories[0];


    let rootRegions = this.props.rootRegions;
    let rootRegionsStr = rootRegions[0];


    let index = this.props.index + 1;
    let slideCount = this.props.slideCount;

    let orgId = this.props.orgId;
    let orgUrl = '/organizations/' + orgId + '/';

    let browser = this.props.browser;

    // Compute the height ratio of the banner based on browser width.
    let imgWrapperWidth = '';
    let imgWrapperHeight = '';

    if (browser.greaterThan.desktop) {
      imgWrapperWidth = '1190px';
      imgWrapperHeight = '453px';
    } else if (browser.greaterThan.tabletLandscape) {
      imgWrapperWidth = '100%';
      imgWrapperHeight = browser.width * .4;

    } else if (browser.greaterThan.tablet) {
      imgWrapperWidth = '100%';
      imgWrapperHeight = browser.width * .47;

    } else if (browser.greaterThan.phablet) {
      imgWrapperWidth = '100%';
      imgWrapperHeight = browser.width * .45;

    } else {
      imgWrapperWidth = '100%';
      imgWrapperHeight = browser.width * .667;
    }



    return(

        <div className="homeBannerFeaturedOrgs-cardWrapper">

          <div style={{width: imgWrapperWidth, height: imgWrapperHeight, overflow: 'hidden', position: 'relative'}} className="homeBannerFeaturedOrgs-cardImgWrapperOuter">
            <div className="homeBannerFeaturedOrgs-cardFilter"></div>

            <div style={{backgroundImage: 'url(' + orgImgUrl + ')', backgroundSize: 'cover'}} className="homeBannerFeaturedOrgs-cardImgWrapper"></div>
          </div>




          <Link className="homeBannerFeaturedOrgs-greyLink" to={orgUrl}><div className="homeBannerFeaturedOrgs-cardInfoWrapper">
            <div className="homeBannerFeaturedOrgs-infoTitle">
              FEATURED
            </div>
            <div className="homeBannerFeaturedOrgs-infoName">
              {name}
            </div>
            <div className="homeBannerFeaturedOrgs-infoDescription">
              {description}
            </div>
            <div className="homeBannerFeaturedOrgs-infoCategoryRegion">
              <span><i className="fa fa-home"></i> {rootCategoriesStr}  &nbsp; <i className="fa fa-map-marker"></i> {rootRegionsStr}</span>

              <span className="homeBannerFeaturedOrgs-infoLink"> &nbsp;|&nbsp; Check it out &nbsp;<i className="fa fa-long-arrow-right" aria-hidden="true"></i></span>
            </div>

          </div></Link>
        </div>


    )
  }

}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps
)(FeaturedOrgBannerCard);



// WEBPACK FOOTER //
// ./src/components/homeBanner/FeaturedOrgBannerCard.jsx